import { render, staticRenderFns } from "./BoardButton.vue?vue&type=template&id=10915906"
import script from "./BoardButton.vue?vue&type=script&lang=js"
export * from "./BoardButton.vue?vue&type=script&lang=js"
import style0 from "./BoardButton.vue?vue&type=style&index=0&id=10915906&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports